import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';


class SendAppLinkSmsRequest extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'Send App Link Sms';
        this.Config   = new AppConfig();
        this.sender   = '';
    }

    execute(dispatch, payload, sender) {
        this.sender = sender;
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.sendAppLinkSms, payload);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        if (this.sender !== 'benefit') {
            this.dispatch(Actions.setAppDownStatus(this.response.status === 1 ? true : false));
        }
        else {
            this.dispatch(Actions.setBenefitStatus(this.response.status === 1 ? true : false));
        }
    }
}

export default SendAppLinkSmsRequest;